module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/247.da58f9c0.png";